import { useContext } from "react";
import { GenerateSessionsActionContext } from "./GenerateSessionsActionContext";

function usePrepareGenerateSessions() {
  const { setElementId, setShowModal } = useContext(
    GenerateSessionsActionContext
  );
  return (id: any) => {
    setElementId(id);
    setShowModal(true);
  };
}

export default usePrepareGenerateSessions;
